import styled from 'styled-components';

import {
  FiltersContainer,
  TableContainer,
} from '../../../../components/display/tables/components/MainStyledComponents';
import { ArrowBottom } from '../../../../assets/icons/ArrowBottom';

// Page-level container — mismo patrón que sibling reports
// (HistoricalActionsReport importa Container de workOrders/components/MainStyledComponents).
import {
  Container as PageContainer,
  ContainerButton as PageContainerButton,
} from '../../workOrders/components/MainStyledComponents';

// Re-exportar bajo los mismos nombres para no tocar imports del index.tsx.
export const Container = PageContainer;
export const ContainerButton = PageContainerButton;

// Empty state / loading fallback — mismo "card" suave que otras pantallas usan
// para placeholders sin datos.
export const EmptyState = styled.div`
  padding: ${({ theme }) => theme.spacing.xxl};
  text-align: center;
  color: ${({ theme }) => theme.colors.greyDark};
`;

// Variante de FiltersContainer que reduce opacidad mientras carga.
// Mismo patrón que `ValidationsTable/styles.ts:FiltersWithLoadingStyled`
// — feedback visual de que la tabla está re-fetcheando.
export const FiltersWithLoadingStyled = styled(FiltersContainer)<{ $isLoading: boolean }>`
  opacity: ${(p) => (p.$isLoading ? 0.6 : 1)};
  transition: opacity 200ms ease;
`;

// Wrapper page-level. Patrón canónico `ValidationsTable/styles.ts:27
// ContainerStyled`.
export const ContainerStyled = styled(Container)`
  position: relative;
`;

// Zona de resultados (envuelve la tabla) con `position: relative` para
// anclar el spinner sobre la tabla.
//
// DIVERGENCIA JUSTIFICADA del canónico: ValidationsTable/AccidentsTable
// ponen el `ContainerLoader` (top:30%) relativo al ContainerStyled que
// envuelve filtros + tabla, y funciona porque su tabla SIEMPRE tiene
// muchas filas (alta). Mi report tiene un filter card bajo (1 fila) y
// la tabla puede estar vacía en la primera carga → el 30% del total
// caía sobre los filtros. Anclando el loader a la zona de resultados,
// el spinner SIEMPRE cae sobre la tabla (igual que se ve en las otras
// pantallas), independiente de la altura del filter card.
export const ResultsZone = styled.div`
  position: relative;
  min-height: 14rem;
`;

// Loader posicionado absolute centrado sobre la ResultsZone.
export const ContainerLoader = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;

// Variante de TableContainer que reduce opacidad mientras carga.
// Copia literal del patrón `AccidentsTable/styles.ts:30` y
// `ValidationsTable/styles.ts:31`. min-height para que el área de la
// tabla tenga altura estable aunque esté vacía — así el spinner
// (ContainerLoader top:30%) siempre cae sobre la zona de datos y no
// sobre los filtros (que es lo que pasaba al ocultar la tabla durante
// el loading).
export const TableContainerStyled = styled(TableContainer)<{
  $isLoading: boolean;
}>`
  opacity: ${(p) => (p.$isLoading ? 0.6 : 1)};
  transition: opacity 200ms ease;
  min-height: 12rem;
`;

// Botón de collapse del card de filtros, visible solo en tablet
// (`isLanscapeTablet`). Mismo aspecto que `ValidationsTable/styles.ts:
// ShowFiltersButton` (fondo garnet / negro al expandir, flecha que rota).
export const ShowFiltersButton = styled.button<{ $isBlack: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  height: 2.3rem;
  padding: 0 ${({ theme }) => theme.spacing.s};
  border-radius: 0.3rem;
  transition: background 300ms;
  background: ${(p) =>
    p.$isBlack ? p.theme.colors.black : p.theme.colors.garnet};
  cursor: pointer;
`;

export const ArrowBottomStyled = styled(ArrowBottom)<{ $isRotate: boolean }>`
  transition: transform 300ms;
  transform: ${(p) => (p.$isRotate ? null : 'rotate(-90deg)')};
  width: 1rem;
  height: 1rem;
  path {
    fill: white;
  }
`;
